import { makeRequest } from "./api";

export const FetchReservations = async (page, limit) => {
  return makeRequest(
    `/api/admin/reservation/fetchPage?page=${page}&limit=${limit}`
  );
};

export const DownloadCSV = async () => {
  return makeRequest("/api/admin/reservation/download-csv");
};

export const FetchReservationDetails = async (id) => {
  return makeRequest(`/api/admin/reservation/fetchOne/${id}`);
};

export const UpdateState = async (reservationId, state) => {
  return makeRequest("/api/host/reservations/updateState", {
    method: "PUT",
    data: {
      reservationId,
      state,
    },
  });
};

export const CancelReservation = async (reservationId) => {
  return makeRequest(`/api/admin/reservation/cancel/${reservationId}`, {
    method: "PUT",
  });
};

export const SearchRecords = async (keyword, page, limit) => {
  return makeRequest(
    `/api/admin/reservation/search?key=${keyword}&page=${page}&limit=${limit}`
  );
};
